import { MessageSquareWarning } from 'lucide-react';

import { iPhoneExperianMock } from '@/shared/assets';
import { Alert, AlertDescription, AlertTitle } from '@/shared/ui/shadcn/alert';
import { Button } from '@/shared/ui/shadcn/button';

export interface ExperianMobileWaitViewProps {
  onRefresh: () => void;
}

/**
 * Wait-for-Experian view shown after DoseSpot's IDP API has triggered an
 * out-of-band Experian mobile verification (the SMS link / "IDCapture" flow,
 * and historically the OTP flow which the V2 workflow folds into the same
 * mobile-verification UX). The clinician completes verification on their
 * phone; this view exists so they have something to look at, and a manual
 * "Refresh" affordance in case the parent query's auto-polling hasn't yet
 * picked up the state transition.
 */
export function ExperianMobileWaitView({ onRefresh }: ExperianMobileWaitViewProps) {
  return (
    <div className="flex h-full flex-col gap-4">
      <div className="min-h-0 flex-1">
        <img
          src={iPhoneExperianMock}
          alt="Experian verification on phone"
          className="h-full object-contain object-left"
        />
      </div>

      <Alert className="shrink-0">
        <MessageSquareWarning aria-hidden="true" />
        <AlertTitle>Don&apos;t see a text from Experian?</AlertTitle>
        <AlertDescription>
          Check your phone&apos;s spam or filtered messages folder — verification texts from
          Experian are sometimes routed there. Once you&apos;ve completed verification on your
          phone, tap Refresh below.
        </AlertDescription>
      </Alert>

      <div className="shrink-0">
        <Button type="button" radius="pill" variant="secondary" onClick={onRefresh}>
          Refresh
        </Button>
      </div>
    </div>
  );
}
